/**
 * UI Language Enum
 */
export enum UILangEnum {
  /**
   * German
   */
  German = 'de',
  /**
   * English (United States)
   */
  English = 'en',
  /**
   * Spanish (Spain)
   */
  Spanish = 'es',
  /**
   * French (France)
   */
  French = 'fr',
  /**
   * Italian (Italy)
   */
  Italian = 'it',
  /**
   * Japanese (Japan)
   */
  Japanese = 'ja',
  /**
   * Korean
   */
  Korean = 'ko',
  /**
   * Chinese Traditional (Taiwan)
   */
  Chinese_Traditional_Taiwan = 'zh-TW',
  /**
   * Chinese Simplified (China)
   */
  Chinese_Simplified_China = 'zh-CN',
  /**
   * Greek (Greece)
   */
  Greek = 'el',
  /**
   * Polish (Poland)
   */
  Polish = 'pl',
}
